import { getActionTypes } from './get-actions';

export const getReducer = (actionPrefix) => (action) => ({
  [getActionTypes(actionPrefix).QUERY_START]: () => ({}),
  [getActionTypes(actionPrefix).QUERY_SUCCESS]: () => ({
    ...action.payload.data,
    error: false,
  }),
  [getActionTypes(actionPrefix).QUERY_FAILURE_GENERIC]: () => ({
    error: {
      status: action.payload.error?.status,
      code: action.payload.error?.code,
      message: action.payload.error?.message,
    },
  }),
  [getActionTypes(actionPrefix).QUERY_FAILURE_401]: () => ({
    error: {
      status: action.payload.error?.status,
      code: action.payload.error?.code,
      message: action.payload.error?.message,
    },
  }),
  [getActionTypes(actionPrefix).SHOW_BANNER_BOTTOM]: () => ({
    showBanner: true,
  }),
  [getActionTypes(actionPrefix).HIDE_BANNER_BOTTOM]: () => ({
    showBanner: false,
  }),
});
